import React, { useEffect, useRef } from "react";
import { useQueryErrorResetBoundary } from "react-query";
import { ErrorBoundary as BaseErrorBoundary } from "react-error-boundary";
import { Alert } from "reactstrap";
import { Trans } from "react-i18next";
import { AppContainer } from "../App";
import { useLocation } from "react-router";

const ErrorAlert = ({ resetErrorBoundary }) => {
  const location = useLocation();
  const mounted = useRef();

  useEffect(() => {
    if (mounted.current) {
      resetErrorBoundary();
    }

    mounted.current = true;
  }, [location, resetErrorBoundary]);

  return (
    <Alert color="danger">
      <Trans>An error occurred.</Trans>
      <button className="btn btn-link btn-sm py-0" onClick={resetErrorBoundary}>
        <Trans>Try again</Trans>
      </button>
    </Alert>
  );
};

export const AppLevelErrorBoundary = ({ children }) => {
  const { reset } = useQueryErrorResetBoundary();

  return (
    <BaseErrorBoundary
      onReset={reset}
      fallbackRender={({ resetErrorBoundary, error }) => (
        <AppContainer>
          <div className="container mt-4">
            <ErrorAlert resetErrorBoundary={resetErrorBoundary} error={error} />
          </div>
        </AppContainer>
      )}
    >
      {children}
    </BaseErrorBoundary>
  );
};

export const TopLevelErrorBoundary = ({ children }) => {
  const { reset } = useQueryErrorResetBoundary();

  return (
    <BaseErrorBoundary
      onReset={reset}
      fallbackRender={({ resetErrorBoundary, error }) => (
        <div className="container mt-4">
          <ErrorAlert resetErrorBoundary={resetErrorBoundary} error={error} />
        </div>
      )}
    >
      {children}
    </BaseErrorBoundary>
  );
};
